import { render, staticRenderFns } from "./UserPermission.vue?vue&type=template&id=e8c95244&scoped=true&"
import script from "./UserPermission.vue?vue&type=script&lang=js&"
export * from "./UserPermission.vue?vue&type=script&lang=js&"
import style0 from "./UserPermission.vue?vue&type=style&index=0&id=e8c95244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c95244",
  null
  
)

export default component.exports